/* TODO: #debito-tecnico Essa arquivo com certeza irá crecer muito. É necessário pensar em uma forma de
* dividir logicamente os campos em vários arquivos. */
import Field from '@tekvue/assets/interfaces/Field';
import Relatorio from './Relatorio';

export enum FieldsNames {
  BASE_SIM_NAO,
  OMITIR_VINCULOS,
  OMITIR_LEGAL,
  INCLUIR_13,
  OMITIR_RESCISAO,
  SO_DEMITIDO,
  MOSTRAR_EVENTOS_DEMONSTRATIVOS,
  TIPO_INCIDENCIA,
  BREAK_BY_FILES,
}

export default class ReportFields {
  constructor(main: Relatorio) {
    this.main = main;
  }

  private main!: Relatorio;

  public get fields(): Record<FieldsNames, Field> {
    return {
      [FieldsNames.BASE_SIM_NAO]: this.baseSimNaoField,
      [FieldsNames.OMITIR_VINCULOS]: this.omitirVinculosField,
      [FieldsNames.OMITIR_LEGAL]: this.omitirLegalField,
      [FieldsNames.INCLUIR_13]: this.incluir13Field,
      [FieldsNames.OMITIR_RESCISAO]: this.omitirRescisaoField,
      [FieldsNames.SO_DEMITIDO]: this.soDemitidoField,
      [FieldsNames.MOSTRAR_EVENTOS_DEMONSTRATIVOS]: this.mostrarDemoField,
      [FieldsNames.TIPO_INCIDENCIA]: this.tipoIncideField,
      [FieldsNames.BREAK_BY_FILES]: this.breakByFilesField,
    };
  }

  private itemsSimNao = [
    {
      name: 'Sim',
      value: 'S',
    },
    {
      name: 'Não',
      value: 'N',
    },
  ];

  public baseSimNaoField: Field = {
    type: 'select',
    items: this.itemsSimNao,
    valueField: 'value',
    descriptionField: 'name',
  };

  private omitirVinculosField: Field = {
    name: 'OMITIRVINCULOS',
    label: 'Omitir Vínculos',
    size: 6,
    ...this.baseSimNaoField,
  };

  private omitirLegalField: Field = {
    name: 'OMITIRLEGAL',
    label: 'Omitir Resumo Legal',
    size: 6,
    ...this.baseSimNaoField,
  };

  private incluir13Field: Field = {
    name: 'INCLUIR13',
    label: 'Incluir 13º Sal. no movimento',
    size: 6,
    ...this.baseSimNaoField,
  };

  private omitirRescisaoField: Field = {
    name: 'OMITIRRESC',
    label: 'Omitir Data de Rescisão',
    size: 6,
    ...this.baseSimNaoField,
  };

  private soDemitidoField: Field = {
    name: 'SODEMITIDO',
    label: 'Somente Vínculos Demitidos',
    size: 6,
    ...this.baseSimNaoField,
  };

  private mostrarDemoField: Field = {
    name: 'MOSTRARDEMO',
    label: 'Mostrar Eventos Demonstrativos',
    size: 6,
    ...this.baseSimNaoField,
  };

  private get tipoIncideField(): Field {
    return {
      name: 'NRTIPOINCIDE',
      label: 'Eventos Ocultos do Tipo de Incidencia',
      size: 6,
      type: 'autocomplete',
      descriptionField: 'DSTIPOINCIDE',
      valueField: 'NRTIPOINCIDE',
      items: this.main ? this.main.fieldsData.tiposIncidencia : [],
    };
  };

  private breakByFilesField: Field =  {
    name: 'BREAKBYFILES',
    label: 'Quebrar por Arquivos',
    size: 6,
    descriptionField: 'name',
    valueField: 'value',
    type: 'select',
    items: [
      {
        name: 'Não',
        value: 'N',
      },
      {
        value: 'LegSup1',
        name: 'Por Hierarquia Superior',
      },
      {
        value: 'LegSupGer1',
        name: 'Por Gerencial',
      },
    ]
  };
}
